module.exports = __webpack_public_path__ + "static/img/samajuri (40).78062e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (40).jpg
// module id = PZRp
// module chunks = 0